import { AccountInteractor } from '@mojility/coach-core';

export default {
  name: 'accountInteractor',
  fn: ['dataService', 'accountGateway', AccountInteractor]
};